<div class="access-error">
  <itb-empty-state-image [imageClass]="'img-404error'"
                         [iconClassName]="'btn-innerico back'" [buttonText]="'back'"
                         [buttonClass]="'btn btn-primary'" [headingClass]="'heading'" (onClickHandler)="backHandler()"
                         [headingText]="'OOPS! SOMETHING WENT WRONG'" [subHeadingClass]="'text-default'"
                         [subHeadingText]="errorMessage" ></itb-empty-state-image>
</div>
